import { render, staticRenderFns } from "./Keypair.vue?vue&type=template&id=1bbc29b8&scoped=true&"
import script from "./Keypair.vue?vue&type=script&lang=js&"
export * from "./Keypair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbc29b8",
  null
  
)

export default component.exports